/* Standing O — Builder. Ported from the approved prototype (Builder.dc.html).
   One page, four moves: Pick your style → Pick your 4 messages → Pick your
   encore → Take a bow → checkout. Desktop and mobile render different trees
   (breakpoint 900px), like the prototype. Catalog comes from metaobjects via
   #so-catalog JSON; commerce config via #so-builder-config. */
(function () {
  'use strict';

  var root = document.getElementById('so-builder');
  if (!root) return;

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var catalog = readJSON('so-catalog', { styles: [] });
  var config = readJSON('so-builder-config', {});
  var defs = (catalog.styles || []).filter(function (s) { return s && s.cards && s.cards.length > 0; });

  /* Extra 3-packs: variants of the Set product, one per extra-pack count
     (index = count). Offered only when at least the "+1" variant exists;
     the cap is the highest count reachable without a gap. */
  var EX = null, EX_MAX = 0;
  (function () {
    var x = config.extras;
    if (!x || !Array.isArray(x.variants)) return;
    var n = 0;
    while (n + 1 < x.variants.length && x.variants[n + 1] && x.variants[n + 1].n === n + 1 && x.variants[n + 1].available !== false) n++;
    n = Math.min(n, parseInt(x.max, 10) || n);
    if (n >= 1) { EX = x; EX_MAX = n; }
  })();
  function exVariant(n) { return EX ? EX.variants[n] : null; }

  if (!defs.length) {
    root.innerHTML =
      '<div class="so-bsetup">' +
      '<h2>The builder needs its catalog</h2>' +
      '<p>No card styles were found. Add them in <strong>Admin → Content → Metaobjects</strong>: create <code>Card message</code> entries (label + art), group them in <code>Card style</code> entries, then list the styles in the <code>Card catalog</code> entry with handle <code>main</code>.</p>' +
      '<p>The included seed script does all of this with placeholder art — see SETUP.md in the theme package.</p>' +
      '</div>';
    return;
  }

  /* A style's public URL key: its name handleized minus a leading "the-"
     ("The Bold" → bold). Must match snippets/so-lp-alias.liquid. Ad links
     use these (?style=bold) while metaobject handles can differ. */
  function aliasOf(d) {
    var a = String(d.name || d.key || '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return a.indexOf('the-') === 0 ? a.slice(4) : a;
  }
  function resolveStyle(v) {
    if (!v) return null;
    v = String(v).toLowerCase().trim();
    for (var i = 0; i < defs.length; i++) { if (defs[i].key === v) return defs[i].key; }
    for (var j = 0; j < defs.length; j++) { if (aliasOf(defs[j]) === v) return defs[j].key; }
    return null;
  }

  /* ---------------------------------------------------------------- state */
  var STORE_KEY = 'so-builder-v1';
  var QTY_MAX = 25;
  var state = {
    move: 1, acc1: null, styleSel: null, picks: [], acc3: null, encore: null,
    view1: defs[0].key, view3: null, qtyMode: false, qty: 1,
    extras: [], view5: null, acc5: null
  };

  (function restore() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
      if (!saved) return;
      var byKey = function (k) { return defs.some(function (d) { return d.key === k; }); };
      if (saved.styleSel && byKey(saved.styleSel)) state.styleSel = saved.styleSel;
      if (saved.view1 && byKey(saved.view1)) state.view1 = saved.view1;
      if (saved.view3 && byKey(saved.view3)) state.view3 = saved.view3;
      if (saved.acc1 && byKey(saved.acc1)) state.acc1 = saved.acc1;
      if (saved.acc3 && byKey(saved.acc3)) state.acc3 = saved.acc3;
      var sel = defs.find(function (d) { return d.key === state.styleSel; });
      if (sel && Array.isArray(saved.picks)) {
        state.picks = saved.picks.filter(function (p) { return typeof p === 'number' && p >= 0 && p < sel.cards.length; }).slice(0, 4);
      }
      if (saved.encore && byKey(saved.encore.s)) {
        var ed = defs.find(function (d) { return d.key === saved.encore.s; });
        if (typeof saved.encore.i === 'number' && saved.encore.i >= 0 && saved.encore.i < ed.cards.length) state.encore = saved.encore;
      }
      if (EX && Array.isArray(saved.extras)) {
        state.extras = saved.extras.filter(function (x) {
          var xd = x && byKey(x.s) ? defs.find(function (d) { return d.key === x.s; }) : null;
          return xd && typeof x.i === 'number' && x.i >= 0 && x.i < xd.cards.length;
        }).slice(0, EX_MAX);
      }
      if (saved.view5 && byKey(saved.view5)) state.view5 = saved.view5;
      if (saved.acc5 && byKey(saved.acc5)) state.acc5 = saved.acc5;
      if ([1, 2, 3, 4, 5].indexOf(saved.move) !== -1) state.move = saved.move;
      if (state.move === 5 && !EX) state.move = 4;
      if (state.move >= 2 && !state.styleSel) state.move = 1;
      if (state.move >= 4 && (state.picks.length < 4 || !state.encore)) state.move = state.picks.length < 4 ? 2 : 3;
      if (saved.qtyMode === true) {
        state.qtyMode = true;
        var sq = parseInt(saved.qty, 10);
        state.qty = sq >= 1 && sq <= QTY_MAX ? sq : 1;
      }
    } catch (e) {}
  })();

  /* URL contract (landing pages): ?style=<key|alias> preselects,
     ?step=messages opens on The Messages (needs a valid style),
     ?qty=1–25 turns on the quantity step. UTM parameters are remembered
     and written onto the cart as attributes, so they reach the order.
     style/step/qty are consumed once and stripped from the address bar,
     so a reload mid-build never throws the visitor back a move. */
  (function urlContract() {
    var q = new URLSearchParams(location.search);
    var want = resolveStyle(q.get('style'));
    var step = (q.get('step') || '').toLowerCase();
    if (want) {
      if (state.styleSel !== want) { state.picks = []; state.encore = null; state.extras = []; }
      state.styleSel = want;
      state.view1 = want;
      state.acc1 = null;
      state.move = step === 'messages' ? 2 : 1;
    } else if (q.get('style') || step) {
      if (state.move > 1 && !state.styleSel) state.move = 1;
    }
    var qv = parseInt(q.get('qty'), 10);
    if (q.has('qty') && qv >= 1) {
      state.qtyMode = true;
      state.qty = Math.min(QTY_MAX, qv);
    }

    var PASS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid', 'li_fat_id', 'gclid'];
    try {
      var carried = JSON.parse(sessionStorage.getItem('so-utm') || '{}');
      PASS.forEach(function (k) { var v = q.get(k); if (v) carried[k] = v; });
      sessionStorage.setItem('so-utm', JSON.stringify(carried));
    } catch (e) {}

    if (q.has('style') || q.has('step') || q.has('qty')) {
      q.delete('style'); q.delete('step'); q.delete('qty');
      var rest = q.toString();
      try { history.replaceState(history.state, '', location.pathname + (rest ? '?' + rest : '') + location.hash); } catch (e) {}
      persist();
    }
  })();

  function persist() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  var mq = window.matchMedia('(max-width: 900px)');
  var isMobile = mq.matches;
  mq.addEventListener('change', function (e) { isMobile = e.matches; render(); });

  var zoom = 1;
  function applyZoom() {
    var z = Math.min(1.6, Math.max(1, window.innerWidth / 1480));
    zoom = z;
    root.style.zoom = z === 1 ? '' : String(z);
  }
  window.addEventListener('resize', applyZoom);
  applyZoom();

  /* ------------------------------------------------------------- helpers */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function def(key) { return defs.find(function (d) { return d.key === key; }) || null; }
  function selDef() { return def(state.styleSel); }
  function nextKey(key) {
    var i = defs.findIndex(function (d) { return d.key === key; });
    return defs[(i + 1) % defs.length].key;
  }
  function marquee(count, animated, reverse) {
    var dots = '';
    for (var i = 0; i < count; i++) {
      var d = (reverse ? (count - 1 - i) : i) * 90;
      dots += '<span class="so-marquee__dot"' + (animated ? ' style="animation-delay:' + d + 'ms"' : '') + '></span>';
    }
    return '<span class="so-marquee so-marquee--bulb' + (animated ? ' so-marquee--animated' : '') + '" aria-hidden="true">' + dots + '</span>';
  }
  function fan(d, mod) {
    var out = '<span class="so-bfan' + (mod ? ' ' + mod : '') + '" aria-hidden="true">';
    d.cards.slice(0, 3).forEach(function (c) { out += '<img src="' + esc(c.img) + '" alt="" loading="lazy">'; });
    return out + '<span class="so-bfan__space"></span></span>';
  }
  function msgCountLabel(d) { return d.cards.length + ' message options'; }
  function pickPrompt() { return ['Pick 4', '3 more', '2 more', '1 more', "That's 4."][state.picks.length] || ''; }
  function grid2Class(n) { return (n >= 10 && n % 5 === 0) ? 'so-b2__grid so-b2__grid--5' : 'so-b2__grid'; }
  function bannerMode(d) { return d.cards.length <= 8; }

  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'so-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* -------------------------------------------------------------- render */
  var prevPicks = state.picks.length;
  var prevExtras = state.extras.length;
  var pendingFly = null;

  function setState(patch) {
    Object.assign(state, patch);
    persist();
    render();
  }
  function go(m) {
    setState({ move: m });
    window.scrollTo({ top: 0 });
  }

  function cardCell(c, opts) {
    // opts: {a, k, i, picked, badge, encBadge, labelCls}
    var frame = '<span class="so-bcard__frame">' +
      '<img src="' + esc(c.img) + '" alt="' + esc(c.label) + '" loading="lazy" class="so-card-cover">' +
      (opts.badge ? '<span class="so-bcard__badge">' + esc(opts.badge) + '</span>' : '') +
      (opts.encBadge ? '<span class="so-bcard__badge so-bcard__badge--enc">Encore</span>' : '') +
      '</span>' +
      '<span class="so-bcard__label">' + esc(c.label) + '</span>';
    if (opts.a) {
      return '<button type="button" class="so-bcard' + (opts.picked ? ' is-picked' : '') + '" data-a="' + opts.a + '"' +
        (opts.k ? ' data-k="' + esc(opts.k) + '"' : '') + ' data-i="' + opts.i + '"' +
        (opts.pressed != null ? ' aria-pressed="' + opts.pressed + '"' : '') + '>' + frame + '</button>';
    }
    return '<div class="so-bcard">' + frame + '</div>';
  }

  function thenBoxes() {
    var out = '<div class="so-bthen"><div class="so-eyebrow so-bthen__label">Then</div>';
    if (state.styleSel) {
      out += '<button type="button" class="so-bthen__box" data-a="go" data-i="2">' +
        '<span><span class="so-eyebrow so-bthen__eyebrow so-bthen__eyebrow--ready" style="display:block">Up next · Move 02</span>' +
        '<span class="so-bthen__name">The messages</span></span>' +
        '<span class="so-bthen__arrow">→</span></button>';
    } else {
      out += '<div class="so-bthen__box so-bthen__box--wait">' +
        '<span><span class="so-eyebrow so-bthen__eyebrow" style="display:block">Move 02</span>' +
        '<span class="so-bthen__name">The messages</span></span>' +
        '<span class="so-eyebrow">Style first</span></div>';
    }
    out += '<div class="so-bthen__box--enc">' +
      '<span><span class="so-eyebrow so-bthen__eyebrow" style="display:block">Move 03</span>' +
      '<span class="so-bthen__name">The encore</span></span>' +
      '<span class="so-eyebrow">Any style</span></div></div>';
    return out;
  }

  /* --------------------------------------------------- desktop: move 01 */
  function rDesktop1() {
    var d1 = def(state.view1) || defs[0];
    var railScroll = defs.length > 6 ? ' so-brail__list--scroll' : '';
    var rail = '<div class="so-brail__list' + railScroll + '">';
    defs.forEach(function (d) {
      var viewing = state.view1 === d.key;
      var selected = state.styleSel === d.key;
      rail += '<div class="so-brail__tile' + (viewing ? ' is-viewing' : '') + '">' +
        '<button type="button" class="so-brail__row" data-a="view1" data-k="' + esc(d.key) + '" style="width:100%;text-align:left">' +
        fan(d) +
        '<span class="so-brail__body"><span class="so-brail__name" style="display:block">' + esc(d.name) + '</span>' +
        '<span class="so-brail__tag" style="display:block">' + esc(d.tag) + '</span></span>' +
        '</button>';
      if (viewing && !selected) rail += '<button type="button" class="so-brail__select" data-a="select1" data-k="' + esc(d.key) + '">Select</button>';
      if (selected) rail += '<span class="so-brail__selected">Selected</span>';
      rail += '</div>';
    });
    rail += '</div>';

    var stage;
    var selBtn = function (light) {
      var isSel = state.styleSel === state.view1;
      return '<button type="button" class="so-bselect' + (light ? ' so-bselect--light' : '') + (isSel ? ' is-selected' : '') + '" data-a="dselect" aria-pressed="' + isSel + '">' +
        (isSel ? 'Selected' : 'Select this style') + '</button>';
    };
    if (bannerMode(d1)) {
      var cells1 = '';
      d1.cards.forEach(function (c) { cells1 += cardCell(c, {}); });
      stage = '<div class="so-bstage__banner">' +
        '<div class="so-bstage__banner-body"><div class="so-bstage__banner-name">' + esc(d1.name) + '</div>' +
        '<div class="so-bstage__banner-sub">' + esc(d1.tag) + ' · ' + msgCountLabel(d1) + '</div></div>' +
        selBtn(false) + '</div>' +
        '<div class="so-bstage__grid">' + cells1 + '</div>';
    } else {
      var cells2 = '<div class="so-bstage__cellhead">' +
        '<div class="so-bstage__cellhead-name">' + esc(d1.name) + '</div>' +
        '<div class="so-bstage__cellhead-sub">' + esc(d1.tag) + ' · ' + msgCountLabel(d1) + '</div>' +
        selBtn(true) + '</div>';
      d1.cards.forEach(function (c) { cells2 += cardCell(c, {}); });
      stage = '<div class="so-bstage__grid">' + cells2 + '</div>';
    }

    return '<div class="so-b1">' +
      '<div class="so-eyebrow so-b1__eyebrow">Move 01 of 03</div>' +
      '<div class="so-b1__head"><h1 class="so-display">Pick your style</h1>' +
      '<span class="so-b1__meta">' + defs.length + ' styles · ' + msgCountLabel(d1) + ' · similar words, different resonance</span></div>' +
      '<div class="so-b1__cols">' +
      '<div class="so-brail">' + rail + thenBoxes() + '</div>' +
      '<div class="so-bstage">' + stage +
      '<div class="so-bstage__note">You’re picking the look — the <strong>actual card messages</strong> get selected in the next move.</div>' +
      '</div></div></div>';
  }

  /* ---------------------------------------------------- desktop: strip */
  function rStrip() {
    var sel = selDef();
    var out = '<div class="so-bstrip"><div class="so-bstrip__grid">' +
      '<button type="button" class="so-bstrip__done" data-a="go" data-i="1">' +
      '<span><span class="so-eyebrow">Move 01</span>' +
      '<span class="so-bstrip__done-name" style="display:block">' + esc(sel ? sel.name : '') + '</span>' +
      '<span class="so-bstrip__done-link" style="display:block">← Change style</span></span>' +
      '<span class="so-bstrip__done-glyph">Done</span></button>';
    if (state.move === 2) {
      out += '<div class="so-bstrip__active"><span class="so-eyebrow">Move 02</span>' +
        '<div class="so-bstrip__active-name">Pick your <em>four</em> messages</div>' +
        '<div class="so-bstrip__active-sub">Each pick is a pack of 3 identical cards</div></div>' +
        '<div class="so-bstrip__wait"><span class="so-eyebrow">Move 03</span>' +
        '<div class="so-bstrip__active-name">The encore</div>' +
        '<div class="so-bstrip__active-sub">One more pack of 3</div></div>';
    } else {
      out += '<button type="button" class="so-bstrip__done" data-a="go" data-i="2">' +
        '<span><span class="so-eyebrow">Move 02</span>' +
        '<span class="so-bstrip__done-name" style="display:block">The messages</span>' +
        '<span class="so-bstrip__done-link" style="display:block">← Change messages</span></span>' +
        '<span class="so-bstrip__done-glyph">Done</span></button>' +
        '<div class="so-bstrip__active"><span class="so-eyebrow">Move 03</span>' +
        '<div class="so-bstrip__active-name">Pick your <em>encore</em></div>' +
        '<div class="so-bstrip__active-sub">One more pack of 3</div></div>';
    }
    return out + '</div></div>';
  }

  /* --------------------------------------------------- desktop: move 02 */
  function rDesktop2() {
    var sel = selDef();
    var cells = '';
    sel.cards.forEach(function (c, i) {
      var count = state.picks.filter(function (p) { return p === i; }).length;
      cells += cardCell(c, { a: 'pick2', i: i, picked: count > 0, badge: count > 0 ? '×' + count : null, pressed: count > 0 });
    });
    var slots = '';
    for (var i = 0; i < 4; i++) {
      var p = state.picks[i];
      var m = (p != null) ? sel.cards[p] : null;
      if (m) {
        slots += '<div class="so-btray__slot"><img src="' + esc(m.img) + '" alt="' + esc(m.label) + '">' +
          '<button type="button" class="so-btray__x" data-a="unpick" data-i="' + i + '" aria-label="Remove ' + esc(m.label) + '">×</button></div>';
      } else {
        slots += '<div class="so-btray__empty">Pack 0' + (i + 1) + '</div>';
      }
    }
    var full = state.picks.length === 4;
    return '<div class="so-b2"><div class="so-b2__stage">' +
      '<div class="' + grid2Class(sel.cards.length) + '">' + cells + '</div>' +
      '<div class="so-b2__hint">Love one? Pick it twice.</div>' +
      '</div></div>' +
      '<div class="so-btray"><div class="so-btray__inner">' +
      '<div class="so-btray__slots">' + slots + '</div>' +
      '<div class="so-btray__count"><span class="so-eyebrow">Your 4 picks</span>' +
      '<span class="so-btray__count-row"><span class="so-display so-btray__count-num">' + (state.picks.length * 3) + '</span>' +
      '<span class="so-btray__count-of">/ 12 cards</span></span></div>' +
      '<div class="so-btray__right">' +
      '<span class="so-display so-btray__prompt" data-so-prompt>' + esc(pickPrompt()) + '</span>' +
      (full
        ? '<button type="button" class="so-btn so-btn--primary so-btn--md" data-a="go" data-i="3">The Encore →</button>'
        : '<span class="so-bpill--disabled">The Encore →</span>') +
      '</div></div></div>';
  }

  /* --------------------------------------------------- desktop: move 03 */
  function rDesktop3() {
    var d3 = state.view3 ? def(state.view3) : null;
    var railScroll = defs.length > 6 ? ' so-brail__list--scroll' : '';
    var rail = '<div class="so-brail__list' + railScroll + '">';
    defs.forEach(function (d) {
      var viewing = state.view3 === d.key;
      var hasEnc = !!(state.encore && state.encore.s === d.key);
      rail += '<div class="so-brail__tile' + (viewing ? ' is-viewing' : '') + '">' +
        '<button type="button" class="so-brail__row" data-a="view3" data-k="' + esc(d.key) + '" style="width:100%;text-align:left">' +
        fan(d, 'so-bfan--sm') +
        '<span class="so-brail__body"><span class="so-brail__name" style="display:block">' + esc(d.name) + '</span>' +
        '<span class="so-brail__tag" style="display:block">' + esc(d.tag) + '</span></span>' +
        '</button>' +
        (hasEnc ? '<span class="so-brail__encbadge">Encore</span>' : '') +
        '</div>';
    });
    rail += '</div>';
    var miniPitch = d3
      ? '<div class="so-bpitch--mini" data-so-minipitch>' +
        '<span class="so-eyebrow">Encore</span>' +
        '<div class="so-display so-bpitch__l1">One more pack of 3</div>' +
        '<div class="so-display so-bpitch__l2">Any message from any style</div>' +
        '<div class="so-bpitch__it">The Encore covers everything.</div></div>'
      : '';

    var stage;
    if (!d3) {
      stage = '<div class="so-bpitch" data-so-pitch>' +
        '<span class="so-eyebrow">Encore</span>' +
        '<div class="so-display so-bpitch__l1">One more pack of 3</div>' +
        '<div class="so-display so-bpitch__l2">Any message from any style</div>' +
        '<div class="so-bpitch__it">The Encore covers everything.</div>' +
        '<div class="so-bpitch__nudge"><span class="so-bpitch__arrow">←</span>' +
        '<span class="so-bpitch__nudge-label">Pick a style to start browsing</span></div>' +
        '<div class="so-bpitch__rule">' + marquee(12, true) + '</div></div>';
    } else {
      var mk = function (c, i) {
        var isSel = !!(state.encore && state.encore.s === d3.key && state.encore.i === i);
        return cardCell(c, { a: 'pickenc', k: d3.key, i: i, picked: isSel, encBadge: isSel, pressed: isSel });
      };
      var inner;
      if (bannerMode(d3)) {
        var cells = '';
        d3.cards.forEach(function (c, i) { cells += mk(c, i); });
        inner = '<div class="so-b3__banner"><div style="flex:1;min-width:0">' +
          '<div class="so-b3__banner-name">' + esc(d3.name) + '</div>' +
          '<div class="so-b3__banner-sub">' + esc(d3.tag) + ' · ' + msgCountLabel(d3) + '</div></div>' +
          '<span class="so-eyebrow so-b3__banner-hint">Tap a card to make it your encore</span></div>' +
          '<div class="so-b3__grid">' + cells + '</div>';
      } else {
        var cells2 = '<div class="so-b3__cellhead">' +
          '<div class="so-b3__cellhead-name">' + esc(d3.name) + '</div>' +
          '<div class="so-b3__cellhead-sub">' + esc(d3.tag) + '</div>' +
          '<div class="so-b3__cellhead-sub">' + msgCountLabel(d3) + '</div></div>';
        d3.cards.forEach(function (c, i) { cells2 += mk(c, i); });
        inner = '<div class="so-b3__grid">' + cells2 + '</div>';
      }
      stage = '<div class="so-b3__stagebox">' + inner + '</div>';
    }

    var enc = state.encore;
    var encDef = enc ? def(enc.s) : null;
    var encCard = encDef ? encDef.cards[enc.i] : null;
    var bar;
    if (!encCard) {
      bar = '<div class="so-bbar__empty"><span class="so-eyebrow">Your encore</span>' +
        '<div class="so-bbar__dash">Tap any card — any style.</div></div>';
    } else {
      bar = '<div class="so-bbar__has">' +
        '<div class="so-bbar__pop"><img src="' + esc(encCard.img) + '" alt="Your encore — ' + esc(encCard.label) + '">' +
        '<button type="button" class="so-bbar__x" data-a="clearenc" aria-label="Remove encore">×</button></div>' +
        '<div class="so-bbar__body"><span class="so-eyebrow">Your encore · pack of 3</span>' +
        '<div class="so-bbar__label">' + esc(encCard.label) + '</div>' +
        '<div class="so-bbar__style">' + esc(encDef.name) + '</div></div>' +
        '<button type="button" class="so-bfinish" data-a="finish">Finish →</button></div>';
    }

    return '<div class="so-b3"><div class="so-b3__cols">' +
      '<div class="so-brail so-brail--enc">' + rail + miniPitch + '</div>' +
      '<div class="so-b3__stagewrap">' + stage + '</div>' +
      '</div></div>' +
      '<div class="so-bbar"><div class="so-bbar__inner">' + bar + '</div></div>';
  }

  /* ------------------------------------------------ desktop: take a bow */
  function doneRows(imgW) {
    var sel = selDef();
    var out = '';
    state.picks.forEach(function (p) {
      var c = sel.cards[p];
      out += '<div class="' + (imgW === 'm' ? 'so-bmdone__row' : 'so-bdone__row') + '">' +
        '<img src="' + esc(c.img) + '" alt="' + esc(c.label) + '">' +
        '<div class="' + (imgW === 'm' ? 'so-bmdone__row-body' : 'so-bdone__row-body') + '">' +
        '<div class="' + (imgW === 'm' ? 'so-bmdone__row-label' : 'so-bdone__row-label') + '">' + esc(c.label) + '</div>' +
        '<div class="' + (imgW === 'm' ? 'so-bmdone__row-style' : 'so-bdone__row-style') + '">' + esc(sel.name) + '</div></div>' +
        '<span class="' + (imgW === 'm' ? 'so-bmdone__pack' : 'so-bdone__pack') + '">Pack of 3</span></div>';
    });
    var ed = def(state.encore.s);
    var ec = ed.cards[state.encore.i];
    out += '<div class="' + (imgW === 'm' ? 'so-bmdone__row so-bmdone__row--enc' : 'so-bdone__row so-bdone__row--enc') + '">' +
      '<img src="' + esc(ec.img) + '" alt="' + esc(ec.label) + '">' +
      '<div class="' + (imgW === 'm' ? 'so-bmdone__row-body' : 'so-bdone__row-body') + '">' +
      '<div class="' + (imgW === 'm' ? 'so-bmdone__row-label' : 'so-bdone__row-label') + '">' + esc(ec.label) + '</div>' +
      '<div class="' + (imgW === 'm' ? 'so-bmdone__row-style' : 'so-bdone__row-style') + '">' + esc(ed.name) + '</div></div>' +
      '<span class="so-bdone__encchip"><span class="so-eyebrow">Encore</span>' +
      '<span class="so-bdone__encchip-pack">Pack of 3</span></span></div>';
    state.extras.forEach(function (x, j) {
      var xd = def(x.s);
      var xc = xd.cards[x.i];
      out += '<div class="' + (imgW === 'm' ? 'so-bmdone__row so-bmdone__row--x' : 'so-bdone__row so-bdone__row--x') + '">' +
        '<img src="' + esc(xc.img) + '" alt="' + esc(xc.label) + '">' +
        '<div class="' + (imgW === 'm' ? 'so-bmdone__row-body' : 'so-bdone__row-body') + '">' +
        '<div class="' + (imgW === 'm' ? 'so-bmdone__row-label' : 'so-bdone__row-label') + '">' + esc(xc.label) + '</div>' +
        '<div class="' + (imgW === 'm' ? 'so-bmdone__row-style' : 'so-bdone__row-style') + '">' + esc(xd.name) + '</div></div>' +
        '<span class="so-bdone__xchip"><span class="so-eyebrow">Extra</span>' +
        '<span class="so-bdone__xchip-pack">Pack of 3</span></span>' +
        '<button type="button" class="so-bdone__xremove" data-a="unpick5" data-i="' + j + '" aria-label="Remove extra pack: ' + esc(xc.label) + '">×</button></div>';
    });
    return out;
  }

  /* What one set costs and holds, extras included. */
  function setPrice() {
    var v = EX ? exVariant(state.extras.length) : null;
    return {
      price: v ? v.price : (config.priceFormatted || '$39.80'),
      cents: v ? v.cents : (config.priceCents || 3980),
      cards: 15 + 3 * (EX ? state.extras.length : 0)
    };
  }

  /* Extras keep their own price next to the set's: set line (optional),
     "N extra 3-packs × $6.75", then the total. Nothing without extras. */
  function priceTable(withSet) {
    var n = EX ? state.extras.length : 0;
    if (!n) return '';
    var v = exVariant(n);
    return '<div class="so-bprice">' +
      (withSet ? '<div class="so-bprice__row"><span>Set · 15 cards</span><span>' + esc(config.priceFormatted || '$39.80') + '</span></div>' : '') +
      '<div class="so-bprice__row"><span>' + n + ' extra 3-pack' + (n > 1 ? 's' : '') + ' · ' + n + ' × ' + esc(EX.pack) + '</span><span>+' + esc(v.extra) + '</span></div>' +
      '<div class="so-bprice__row so-bprice__row--total"><span>' + (state.qtyMode ? 'Per set · ' : 'Total · ') + setPrice().cards + ' cards</span><span>' + esc(v.price) + '</span></div>' +
      '</div>';
  }

  /* Wipes every pick (style, messages, encore, extras) and returns to Move 01. */
  function startOver() {
    return '<button type="button" class="so-bstartover" data-a="startover">Clear selection and start over</button>';
  }

  /* Merchant copy for the extras flow, with [n] / [total] / [max] filled in. */
  function exText(key, fallback) {
    var n = state.extras.length;
    var v = exVariant(n);
    return String((EX && EX[key]) || fallback)
      .replace(/\[n\]/g, String(n))
      .replace(/\[total\]/g, v ? v.extra : '')
      .replace(/\[max\]/g, String(EX_MAX));
  }

  /* Offer: extra 3-packs (sits above Make it a double). */
  function extrasTicket() {
    if (!EX) return '';
    var n = state.extras.length;
    return '<div class="so-bxtra"><span class="so-eyebrow">' + esc(EX.eyebrow) + '</span>' +
      '<div class="so-bxtra__h">' + esc(EX.heading) + '</div>' +
      '<p class="so-bxtra__copy">' + (EX.copy || '') +
      (EX.copy2 ? '<span class="so-bxtra__copy2">' + EX.copy2 + '</span>' : '') + '</p>' +
      (n ? '<p class="so-bxtra__status">' + esc(exText('status', 'Extra packs added: [n] · +[total]')) + '</p>' : '') +
      '<button type="button" class="so-btn so-btn--primary so-btn--sm" data-a="extras">' +
      esc(n ? exText('change', 'Change extra packs') : (EX.button || 'Pick extra packs')) + '</button></div>';
  }

  /* Quantity step — only when a landing page sent ?qty= (Managers page).
     Identical sets, one checkout, one address. Capped at QTY_MAX. */
  function qtyStep() {
    if (!state.qtyMode) return '';
    var team = config.teamUrl || '/pages/contact?subject=Team%20order&source=managers';
    return '<div class="so-bqty">' +
      '<label class="so-bqty__label" for="so-bqty-input">How many sets?</label>' +
      '<div class="so-bqty__row">' +
      '<button type="button" class="so-bqty__btn" data-a="qty" data-i="-1" aria-label="One fewer set"' + (state.qty <= 1 ? ' disabled' : '') + '>−</button>' +
      '<input id="so-bqty-input" class="so-bqty__input" type="number" inputmode="numeric" min="1" max="' + QTY_MAX + '" value="' + state.qty + '" data-so-qty>' +
      '<button type="button" class="so-bqty__btn" data-a="qty" data-i="1" aria-label="One more set"' + (state.qty >= QTY_MAX ? ' disabled' : '') + '>+</button>' +
      '</div>' +
      '<p class="so-bqty__help">One per manager. For more than 25, <a href="' + esc(team) + '" data-so-team-link>tell us about your team</a>.</p>' +
      '<button type="button" class="so-bqty__another" data-a="another">Add to bag and build a different set</button>' +
      '</div>';
  }

  function doubleTicket() {
    if (state.qtyMode) return '';
    return '<div class="so-bdouble"><span class="so-eyebrow">Somebody else earned one too</span>' +
      '<div class="so-bdouble__h">Make it a double</div>' +
      '<p class="so-bdouble__copy">Two or more sets: <strong>20% off each set + free shipping</strong>.</p>' +
      '<button type="button" class="so-btn so-btn--secondary so-btn--sm" data-a="another">Add another set</button></div>';
  }

  function rDesktopDone() {
    return '<div class="so-bdone">' +
      '<div class="so-bdone__left"><span class="so-eyebrow">Your four picks</span>' +
      '<div class="so-bdone__rows">' + doneRows() + '</div>' + startOver() + '</div>' +
      '<div class="so-bdone__side">' +
      '<div class="so-bdone__hero"><span class="so-eyebrow">Set complete</span>' +
      '<div class="so-display so-bdone__hero-line">Take a bow</div>' +
      '<div class="so-bdone__hero-rule">' + marquee(9, true) + '</div></div>' +
      '<div class="so-bdone__summary">' +
      '<div class="so-bdone__pricebox"><div><div class="so-bdone__price">' + esc(config.priceFormatted || '$39.80') + '</div>' +
      '<div class="so-bdone__price-sub">15 cards</div></div>' +
      '<div class="so-bdone__carrier"><span class="so-bdone__carrier-label"><span>plus</span><span>carrier</span></span>' +
      '<img src="' + esc(config.carrierImg || '') + '" alt="The carrier"></div></div>' +
      priceTable(false) +
      qtyStep() +
      '<div class="so-bdone__checkout"><button type="button" class="so-btn so-btn--primary so-btn--md so-btn--full" data-a="checkout">Continue to checkout →</button></div>' +
      '<p class="so-bdone__caption">You’re getting about 2X the number of cards you would at the average retail store for this price.</p>' +
      '</div>' + extrasTicket() + doubleTicket() + '</div></div>';
  }

  /* ---------------------------------------------- desktop: extra 3-packs */
  function exCount(k, i) {
    return state.extras.filter(function (x) { return x.s === k && x.i === i; }).length;
  }
  function rStrip5() {
    var sel = selDef();
    return '<div class="so-bstrip"><div class="so-bstrip__grid so-bstrip__grid--x">' +
      '<button type="button" class="so-bstrip__done" data-a="go" data-i="4">' +
      '<span><span class="so-eyebrow">Your set</span>' +
      '<span class="so-bstrip__done-name" style="display:block">' + esc(sel ? sel.name : '') + '</span>' +
      '<span class="so-bstrip__done-link" style="display:block">← Back to your set</span></span>' +
      '<span class="so-bstrip__done-glyph">Done</span></button>' +
      '<div class="so-bstrip__active"><span class="so-eyebrow">Extras</span>' +
      '<div class="so-bstrip__active-name">' + (EX.title || 'Add extra 3-packs') + '</div>' +
      '<div class="so-bstrip__active-sub">' + esc(EX.sub) + '</div></div>' +
      '</div></div>';
  }
  function rDesktop5() {
    var d5 = def(state.view5) || selDef() || defs[0];
    var rail = '<div class="so-brail__list' + (defs.length > 6 ? ' so-brail__list--scroll' : '') + '">';
    defs.forEach(function (d) {
      var viewing = d5.key === d.key;
      var inStyle = state.extras.filter(function (x) { return x.s === d.key; }).length;
      rail += '<div class="so-brail__tile' + (viewing ? ' is-viewing' : '') + '">' +
        '<button type="button" class="so-brail__row" data-a="view5" data-k="' + esc(d.key) + '" style="width:100%;text-align:left">' +
        fan(d, 'so-bfan--sm') +
        '<span class="so-brail__body"><span class="so-brail__name" style="display:block">' + esc(d.name) + '</span>' +
        '<span class="so-brail__tag" style="display:block">' + esc(d.tag) + '</span></span>' +
        '</button>' +
        (inStyle ? '<span class="so-brail__encbadge so-brail__xbadge">+' + inStyle + (inStyle > 1 ? ' extras' : ' extra') + '</span>' : '') +
        '</div>';
    });
    rail += '</div>';

    var n = state.extras.length;
    var full = n >= EX_MAX;
    var cells = '';
    d5.cards.forEach(function (c, i) {
      var cnt = exCount(d5.key, i);
      cells += cardCell(c, { a: 'pick5', k: d5.key, i: i, picked: cnt > 0, badge: cnt > 0 ? '×' + cnt : null, pressed: cnt > 0 });
    });
    var stage = '<div class="so-b3__stagebox so-b5__stagebox">' +
      '<div class="so-b3__banner"><div style="flex:1;min-width:0">' +
      '<div class="so-b3__banner-name">' + esc(d5.name) + '</div>' +
      '<div class="so-b3__banner-sub">' + esc(d5.tag) + ' · ' + msgCountLabel(d5) + '</div></div>' +
      '<span class="so-eyebrow so-b3__banner-hint">' + esc(full ? exText('full', 'That’s [max] — the most a set takes.') : exText('hint', 'Tap a card to add a pack of 3')) + '</span></div>' +
      '<div class="so-b3__grid' + (full ? ' is-full' : '') + '">' + cells + '</div>' +
      '<div class="so-b2__hint">Love one? Pick it twice.</div></div>';

    var slots = '';
    for (var s = 0; s < EX_MAX; s++) {
      var x = state.extras[s];
      var xd = x ? def(x.s) : null;
      var xc = xd ? xd.cards[x.i] : null;
      if (xc) {
        slots += '<div class="so-btray__slot so-btray__slot--x"><img src="' + esc(xc.img) + '" alt="' + esc(xc.label) + ', ' + esc(xd.name) + '">' +
          '<button type="button" class="so-btray__x" data-a="unpick5" data-i="' + s + '" aria-label="Remove ' + esc(xc.label) + '">×</button></div>';
      } else {
        slots += '<div class="so-btray__empty">Extra 0' + (s + 1) + '</div>';
      }
    }
    return '<div class="so-b3 so-b5"><div class="so-b3__cols">' +
      '<div class="so-brail so-brail--enc">' + rail + '</div>' +
      '<div class="so-b3__stagewrap">' + stage + '</div>' +
      '</div></div>' +
      '<div class="so-btray"><div class="so-btray__inner">' +
      '<div class="so-btray__slots">' + slots + '</div>' +
      '<div class="so-btray__count"><span class="so-eyebrow">' + esc(exText('tray', 'Extra packs')) + '</span>' +
      '<span class="so-btray__count-row"><span class="so-display so-btray__count-num">+' + (n * 3) + '</span>' +
      '<span class="so-btray__count-of">cards</span></span></div>' +
      '<div class="so-btray__right">' +
      '<span class="so-display so-btray__prompt so-btray__prompt--x" data-so-xprompt>' + (n ? '+' + esc(exVariant(n).extra) : esc(EX.pack) + ' a pack') + '</span>' +
      '<button type="button" class="so-btn so-btn--primary so-btn--md" data-a="go" data-i="4">Done →</button>' +
      '</div></div></div>';
  }

  /* ------------------------------------------------------------- mobile */
  function moveLabel() {
    var sel = selDef();
    return state.move === 1 ? 'Move 01 of 03'
      : state.move === 2 ? 'Move 02 of 03 · ' + (sel ? sel.name : '')
      : state.move === 3 ? 'Move 03 of 03'
      : state.move === 5 ? 'Extras'
      : 'Set complete';
  }

  function rMobileTop() {
    var back = '';
    if (state.move === 2 || state.move === 3) {
      back = '<button type="button" class="so-bback" data-a="go" data-i="' + (state.move === 3 ? 2 : 1) + '">' +
        (state.move === 2 ? '← Back to style' : '← Back to messages') + '</button>';
    } else if (state.move === 5) {
      back = '<button type="button" class="so-bback" data-a="go" data-i="4">← Back to your set</button>';
    }
    return '<div class="so-bm__top"><span class="so-eyebrow">' + esc(moveLabel()) + '</span>' + back + '</div>';
  }

  function rMobile1() {
    var d1 = def(state.view1) || defs[0];
    var out = '<h1 class="so-display so-bm__h1">Pick your style</h1>' +
      '<p class="so-bm__sub">' + defs.length + ' styles · ' + msgCountLabel(d1) + ' · tap to flip through</p>';
    defs.forEach(function (d) {
      var expanded = state.acc1 === d.key;
      var selected = state.styleSel === d.key;
      out += '<div class="so-bacc' + (selected ? ' is-selected' : '') + '">' +
        '<div class="so-bacc__row" data-a="acc1" data-k="' + esc(d.key) + '" role="button" tabindex="0" aria-expanded="' + expanded + '">' +
        (expanded ? '' : fan(d, 'so-bfan--m')) +
        '<span class="so-bacc__body-meta"><span class="so-bacc__name" style="display:block">' + esc(d.name) + '</span>' +
        '<span class="so-bacc__tag" style="display:block">' + esc(d.tag) + '</span></span>' +
        (expanded
          ? '<span class="so-bacc__btns">' +
            (selected
              ? '<span class="so-bacc__select">Selected</span>'
              : '<button type="button" class="so-bacc__select" data-a="select1" data-k="' + esc(d.key) + '">Select this style</button>') +
            '<button type="button" class="so-bacc__next" data-a="next1" data-k="' + esc(d.key) + '">Next style</button></span>'
          : '') +
        '<span class="so-bacc__glyph">' + (expanded ? '×' : '+') + '</span>' +
        '</div>';
      if (expanded) {
        var grid = '';
        d.cards.forEach(function (c) {
          grid += '<div><img src="' + esc(c.img) + '" alt="' + esc(c.label) + '" loading="lazy" class="so-card-cover" style="border-radius:6px;border:1px solid var(--border-quiet);background:var(--cream-100)">' +
            '<div style="margin-top:5px;font-size:12.5px;color:var(--ink-600)">' + esc(c.label) + '</div></div>';
        });
        out += '<div class="so-bacc__panel"><div class="so-bacc__grid">' + grid + '</div>' +
          '<div class="so-bacc__note">You’re picking the look — the <strong>actual card messages</strong> get selected in the next move.</div>' +
          '<button type="button" class="so-bacc__close" data-a="acc1" data-k="' + esc(d.key) + '">Close ×</button></div>';
      }
      if (selected) out += '<div class="so-bacc__strip">Selected</div>';
      out += '</div>';
    });
    out += thenBoxes();
    return out;
  }

  function rMobile2() {
    var sel = selDef();
    var grid = '';
    sel.cards.forEach(function (c, i) {
      var count = state.picks.filter(function (p) { return p === i; }).length;
      grid += cardCell(c, { a: 'pick2', i: i, picked: count > 0, badge: count > 0 ? '×' + count : null, pressed: count > 0 });
    });
    return '<h1 class="so-display so-bm__h1">Pick your <em>four</em> messages</h1>' +
      '<p class="so-bm__sub--tight" style="color:var(--text-muted)">Each pick is a pack of 3 identical cards.</p>' +
      '<p class="so-bm__sub--it">Love one? Pick it twice.</p>' +
      '<div class="so-bm__grid2">' + grid + '</div>';
  }

  function rMobile3() {
    var out = '<h1 class="so-display so-bm__h1">Pick your <em>encore</em></h1>' +
      '<div class="so-bticketrow"><span class="so-bticket">One more<br>pack of 3</span>' +
      '<p><span>Any message from any style.</span><span>The Encore covers everything.</span></p></div>';
    defs.forEach(function (d) {
      var expanded = state.acc3 === d.key;
      out += '<div class="so-bacc">' +
        '<button type="button" class="so-bacc__row" style="gap:16px" data-a="acc3" data-k="' + esc(d.key) + '" aria-expanded="' + expanded + '">' +
        fan(d, 'so-bfan--m') +
        '<span class="so-bacc__body-meta"><span class="so-bacc__name" style="display:block">' + esc(d.name) + '</span>' +
        '<span class="so-bacc__tag" style="display:block">' + esc(d.tag) + '</span></span>' +
        '<span class="so-bacc__glyph">' + (expanded ? '×' : '+') + '</span></button>';
      if (expanded) {
        var grid = '';
        d.cards.forEach(function (c, i) {
          var isSel = !!(state.encore && state.encore.s === d.key && state.encore.i === i);
          grid += cardCell(c, { a: 'pickenc', k: d.key, i: i, picked: isSel, encBadge: isSel, pressed: isSel });
        });
        out += '<div class="so-bacc__panel"><div class="so-bacc__grid so-bacc__grid--enc">' + grid + '</div>' +
          '<div class="so-bacc__links">' +
          '<button type="button" class="close" data-a="acc3" data-k="' + esc(d.key) + '">Close ×</button>' +
          '<button type="button" class="next" data-a="next3" data-k="' + esc(d.key) + '">Next style →</button>' +
          '</div></div>';
      }
      out += '</div>';
    });
    return out;
  }

  function rMobileDone() {
    return '<div class="so-bmdone">' +
      '<div class="so-bmdone__hero"><span class="so-eyebrow">Set complete</span>' +
      '<div class="so-display so-bmdone__hero-line">Take a bow</div>' +
      '<div class="so-bmdone__hero-sub">' + setPrice().cards + ' cards plus the carrier</div>' +
      '<div class="so-bmdone__hero-rule">' + marquee(10, true) + '</div></div>' +
      '<div class="so-bmdone__wrap"><span class="so-eyebrow">Your four picks</span>' +
      '<div class="so-bmdone__rows">' + doneRows('m') + '</div>' +
      priceTable(true) + startOver() +
      (state.qtyMode ? '<div class="so-bmdone__qty">' + qtyStep() + '</div>' : '') +
      '<div class="so-bmdone__double">' + extrasTicket() + doubleTicket() + '</div>' +
      '</div></div>';
  }

  function rMobile5() {
    var out = '<h1 class="so-display so-bm__h1">' + (EX.title || 'Add extra 3-packs') + '</h1>' +
      '<p class="so-bm__sub--tight" style="color:var(--text-muted)">' + esc(EX.sub) + '</p>' +
      '<p class="so-bm__sub--it">Love one? Pick it twice.</p>';
    defs.forEach(function (d) {
      var expanded = state.acc5 === d.key;
      var inStyle = state.extras.filter(function (x) { return x.s === d.key; }).length;
      out += '<div class="so-bacc">' +
        '<button type="button" class="so-bacc__row" style="gap:16px" data-a="acc5" data-k="' + esc(d.key) + '" aria-expanded="' + expanded + '">' +
        fan(d, 'so-bfan--m') +
        '<span class="so-bacc__body-meta"><span class="so-bacc__name" style="display:block">' + esc(d.name) + '</span>' +
        '<span class="so-bacc__tag" style="display:block">' + esc(d.tag) + (inStyle ? ' · <b class="so-bacc__xcount">+' + inStyle + ' picked</b>' : '') + '</span></span>' +
        '<span class="so-bacc__glyph">' + (expanded ? '×' : '+') + '</span></button>';
      if (expanded) {
        var grid = '';
        d.cards.forEach(function (c, i) {
          var cnt = exCount(d.key, i);
          grid += cardCell(c, { a: 'pick5', k: d.key, i: i, picked: cnt > 0, badge: cnt > 0 ? '×' + cnt : null, pressed: cnt > 0 });
        });
        out += '<div class="so-bacc__panel"><div class="so-bacc__grid so-bacc__grid--enc' + (state.extras.length >= EX_MAX ? ' is-full' : '') + '">' + grid + '</div>' +
          '<div class="so-bacc__links">' +
          '<button type="button" class="close" data-a="acc5" data-k="' + esc(d.key) + '">Close ×</button>' +
          '<button type="button" class="next" data-a="next5" data-k="' + esc(d.key) + '">Next style →</button>' +
          '</div></div>';
      }
      out += '</div>';
    });
    return out;
  }

  function rMobileBars() {
    var sel = selDef();
    if (state.move === 1 && state.acc1 === null && state.styleSel !== null) {
      return '<div class="so-bmbar so-bmbar--ink"><div class="so-bmbar__inner so-bmbar__inner--between">' +
        '<div><span class="so-eyebrow so-bmbar__lockeyebrow" style="display:block">Locked in</span>' +
        '<span class="so-bmbar__lockname">' + esc(sel.name) + '</span></div>' +
        '<button type="button" class="so-btn so-btn--primary so-btn--md" data-a="go" data-i="2">Messages →</button>' +
        '</div></div>';
    }
    if (state.move === 2) {
      var slots = '';
      for (var i = 0; i < 4; i++) {
        var p = state.picks[i];
        var m = (p != null) ? sel.cards[p] : null;
        if (m) {
          slots += '<button type="button" class="so-bmbar__slot" data-a="unpick" data-i="' + i + '" aria-label="Remove ' + esc(m.label) + '">' +
            '<img src="' + esc(m.img) + '" alt=""><span>×</span></button>';
        } else {
          slots += '<div class="so-bmbar__empty">Pack 0' + (i + 1) + '</div>';
        }
      }
      var full = state.picks.length === 4;
      return '<div class="so-bmbar so-bmbar--cream"><div class="so-bmbar__inner" style="flex-wrap:wrap">' +
        '<div class="so-bmbar__slots">' + slots + '</div>' +
        '<span class="so-bmbar__count"><span class="so-display num" data-so-prompt>' + (state.picks.length * 3) + '</span><span class="of">/ 12 cards</span></span>' +
        '<div class="so-bmbar__spacer"></div>' +
        (full
          ? '<button type="button" class="so-btn so-btn--primary so-btn--md" data-a="go" data-i="3">The Encore →</button>'
          : '<span class="so-bpill--disabled" style="flex:none;padding:12px 20px">The Encore →</span>') +
        '</div></div>';
    }
    if (state.move === 3) {
      var enc = state.encore;
      var encDef = enc ? def(enc.s) : null;
      var encCard = encDef ? encDef.cards[enc.i] : null;
      if (!encCard) {
        return '<div class="so-bmbar so-bmbar--ink3"><div style="max-width:980px;margin:0 auto">' +
          '<span class="so-eyebrow so-bmbar__enceyebrow">Your encore</span>' +
          '<div class="so-bmbar__encempty">Tap any card — any style.</div></div></div>';
      }
      return '<div class="so-bmbar so-bmbar--ink3"><div class="so-bmbar__inner" style="gap:16px">' +
        '<div class="so-bmbar__pop"><img src="' + esc(encCard.img) + '" alt="Your encore">' +
        '<button type="button" class="so-bbar__x" data-a="clearenc" aria-label="Remove encore">×</button></div>' +
        '<div style="flex:1;min-width:0"><span class="so-eyebrow" style="color:var(--brass-300);margin-bottom:4px;display:block">Your encore · pack of 3</span>' +
        '<div style="font-family:var(--font-display);font-weight:800;text-transform:uppercase;font-size:21px;line-height:.95;color:var(--cream-200)">' + esc(encCard.label) + '</div>' +
        '<div style="font-size:12px;color:var(--text-inverse-muted);margin-top:3px">' + esc(encDef.name) + '</div></div>' +
        '<button type="button" class="so-bmbar__finish" data-a="finish">Finish →</button>' +
        '</div></div>';
    }
    if (state.move === 4) {
      var xn4 = EX ? state.extras.length : 0;
      return '<div class="so-bmbar so-bmbar--cream"><div class="so-bmbar__inner so-bmbar__inner--between' + (xn4 ? ' so-bmbar__inner--x' : '') + '">' +
        '<div><div class="so-bmbar__price">' + esc(setPrice().price) + '</div>' +
        '<div class="so-bmbar__price-sub">' + (xn4
          ? 'incl. +' + esc(exVariant(xn4).extra) + ' extra' + (xn4 > 1 ? 's' : '')
          : '15 cards') + '</div></div>' +
        '<div class="so-bmbar__carrier"><span class="so-bmbar__carrier-label"><span>plus</span><span>carrier</span></span>' +
        '<img src="' + esc(config.carrierImg || '') + '" alt=""></div>' +
        '<button type="button" class="so-btn so-btn--primary so-btn--sm" data-a="checkout">Checkout →</button>' +
        '</div></div>';
    }
    if (state.move === 5) {
      var xslots = '';
      for (var xi = 0; xi < EX_MAX; xi++) {
        var x = state.extras[xi];
        var xd = x ? def(x.s) : null;
        var xc = xd ? xd.cards[x.i] : null;
        if (xc) {
          xslots += '<button type="button" class="so-bmbar__slot so-bmbar__slot--x" data-a="unpick5" data-i="' + xi + '" aria-label="Remove ' + esc(xc.label) + '">' +
            '<img src="' + esc(xc.img) + '" alt=""><span>×</span></button>';
        } else {
          xslots += '<div class="so-bmbar__empty">Extra 0' + (xi + 1) + '</div>';
        }
      }
      var xn = state.extras.length;
      return '<div class="so-bmbar so-bmbar--cream"><div class="so-bmbar__inner" style="flex-wrap:wrap">' +
        '<div class="so-bmbar__slots">' + xslots + '</div>' +
        '<span class="so-bmbar__count"><span class="so-display num" data-so-xprompt>+' + (xn * 3) + '</span>' +
        '<span class="of">cards' + (xn ? ' · +' + esc(exVariant(xn).extra) : '') + '</span></span>' +
        '<div class="so-bmbar__spacer"></div>' +
        '<button type="button" class="so-btn so-btn--primary so-btn--md" data-a="go" data-i="4">Done →</button>' +
        '</div></div>';
    }
    return '';
  }

  /* --------------------------------------------------------- render root */
  function render() {
    var html;
    if (isMobile) {
      var body = state.move === 1 ? rMobile1() : state.move === 2 ? rMobile2() : state.move === 3 ? rMobile3() : state.move === 5 ? rMobile5() : rMobileDone();
      html = '<div class="so-bm">' + rMobileTop() + body + '</div>' + rMobileBars();
    } else {
      if (state.move === 1) html = rDesktop1();
      else if (state.move === 2) html = rStrip() + rDesktop2();
      else if (state.move === 3) html = rStrip() + rDesktop3();
      else if (state.move === 5) html = rStrip5() + rDesktop5();
      else html = rDesktopDone();
    }
    root.innerHTML = html;

    if (state.picks.length !== prevPicks) {
      prevPicks = state.picks.length;
      var el = root.querySelector('[data-so-prompt]');
      if (el) {
        el.classList.remove('is-pop');
        void el.offsetWidth;
        el.classList.add('is-pop');
      }
    } else {
      prevPicks = state.picks.length;
    }
    if (state.extras.length !== prevExtras) {
      prevExtras = state.extras.length;
      var xp = root.querySelector('[data-so-xprompt]');
      if (xp) {
        xp.classList.remove('is-pop');
        void xp.offsetWidth;
        xp.classList.add('is-pop');
      }
    }

    if (pendingFly) {
      var first = pendingFly;
      pendingFly = null;
      requestAnimationFrame(function () {
        var box = root.querySelector('[data-so-minipitch]');
        if (!box) return;
        var last = box.getBoundingClientRect();
        box.style.animation = 'none';
        box.style.transformOrigin = '0 0';
        box.style.transition = 'none';
        box.style.zIndex = '20';
        box.style.position = 'relative';
        var z = zoom || 1;
        box.style.transform = 'translate(' + ((first.left - last.left) / z) + 'px,' + ((first.top - last.top) / z) + 'px) scale(' + (first.width / last.width) + ',' + (first.height / last.height) + ')';
        requestAnimationFrame(function () {
          box.style.transition = 'transform .8s var(--ease-standard)';
          box.style.transform = 'none';
        });
      });
    }
  }

  /* -------------------------------------------------------------- cart */
  function lineItem() {
    var sel = selDef();
    var props = { 'Style': sel.name };
    state.picks.forEach(function (p, i) {
      props['Pack ' + (i + 1)] = sel.cards[p].label + ' × 3';
    });
    var ed = def(state.encore.s);
    var ec = ed.cards[state.encore.i];
    props['Encore'] = ec.label + ' (' + ed.name + ') × 3';
    var extras = EX ? state.extras.slice(0, EX_MAX) : [];
    extras.forEach(function (x, j) {
      var xd = def(x.s);
      props['Extra ' + (j + 1)] = xd.cards[x.i].label + ' (' + xd.name + ') × 3';
    });
    if (extras.length) {
      props['Pricing'] = 'Set ' + (config.priceFormatted || '$39.80') + ' + ' + extras.length + ' extra 3-pack' +
        (extras.length > 1 ? 's' : '') + ' × ' + EX.pack;
    }
    props['_Set'] = JSON.stringify({
      style: sel.key,
      picks: state.picks.map(function (p) { return sel.cards[p].label; }),
      encore: { style: ed.key, message: ec.label },
      extras: extras.map(function (x) { var xd = def(x.s); return { style: xd.key, message: xd.cards[x.i].label }; })
    });
    var field = state.qtyMode ? root.querySelector('[data-so-qty]') : null;
    if (field && field.value !== '') state.qty = clampQty(field.value);
    var v = extras.length ? exVariant(extras.length) : null;
    return {
      id: v ? v.id : config.variantId,
      quantity: state.qtyMode ? state.qty : 1,
      properties: props,
      cents: v ? v.cents : (config.priceCents || 3980)
    };
  }

  /* UTM + landing attribution → cart attributes → the order's
     "Additional details". Never blocks the add if it fails. */
  function syncAttribution() {
    var attrs = null;
    try {
      var c = JSON.parse(sessionStorage.getItem('so-utm') || '{}');
      if (Object.keys(c).length) attrs = c;
    } catch (e) {}
    if (!attrs) return Promise.resolve();
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  var cartBusy = false;
  function addSetToCart() {
    if (!config.variantId) {
      toast('Almost there — connect the Set product in theme settings.');
      return Promise.reject(new Error('no product'));
    }
    if (cartBusy) return Promise.reject(new Error('busy'));
    cartBusy = true;
    var item = lineItem();
    var unitCents = item.cents;
    delete item.cents;
    return syncAttribution().then(function () {
      return fetch(config.addUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (b) { throw new Error(b && b.description || 'add failed'); });
      return r.json();
    }).then(function (res) {
      document.dispatchEvent(new CustomEvent('so:cart:changed'));
      if (window.soTrack) {
        var sel = selDef();
        window.soTrack('AddToCart', {
          value: Math.round(unitCents * item.quantity) / 100,
          currency: config.currency || 'USD',
          style: sel ? aliasOf(sel) : '',
          quantity: item.quantity
        });
      }
      return res;
    }).finally(function () { cartBusy = false; });
  }

  function resetAll() {
    setState({ move: 1, acc1: null, styleSel: null, picks: [], acc3: null, encore: null, view1: defs[0].key, view3: null, qty: 1, extras: [], view5: null, acc5: null });
    window.scrollTo({ top: 0 });
  }

  function clampQty(n) { return Math.max(1, Math.min(QTY_MAX, parseInt(n, 10) || 1)); }
  function setQty(n) { setState({ qty: clampQty(n) }); }
  /* Typing updates state in place, without a re-render: rebuilding the
     tree on blur would swallow the tap that caused the blur (usually
     Continue to checkout). */
  function syncQtyControls(v) {
    root.querySelectorAll('[data-a="qty"]').forEach(function (b) {
      var dir = parseInt(b.getAttribute('data-i'), 10);
      b.disabled = dir < 0 ? v <= 1 : v >= QTY_MAX;
    });
  }
  root.addEventListener('input', function (e) {
    if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-so-qty')) return;
    if (e.target.value === '') return;
    state.qty = clampQty(e.target.value);
    persist();
    syncQtyControls(state.qty);
  });
  root.addEventListener('change', function (e) {
    if (!e.target || !e.target.hasAttribute || !e.target.hasAttribute('data-so-qty')) return;
    state.qty = clampQty(e.target.value);
    persist();
    root.querySelectorAll('[data-so-qty]').forEach(function (el) { el.value = state.qty; });
    syncQtyControls(state.qty);
  });

  /* ------------------------------------------------------------- events */
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest('[data-a][role="button"]');
    if (!t || !root.contains(t)) return;
    e.preventDefault();
    t.click();
  });

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-a]');
    if (!t || !root.contains(t)) return;
    var a = t.getAttribute('data-a');
    var k = t.getAttribute('data-k');
    var i = parseInt(t.getAttribute('data-i'), 10);

    if (a === 'go') { go(i); return; }
    if (a === 'qty') { setQty(state.qty + i); return; }
    if (a === 'view1') { setState({ view1: k }); return; }
    if (a === 'select1') { e.stopPropagation(); setState({ styleSel: k, acc1: null }); return; }
    if (a === 'dselect') { setState({ styleSel: state.styleSel === state.view1 ? null : state.view1 }); return; }
    if (a === 'acc1') { setState({ acc1: state.acc1 === k ? null : k }); return; }
    if (a === 'next1') { e.stopPropagation(); setState({ acc1: nextKey(k) }); return; }
    if (a === 'pick2') {
      if (state.picks.length < 4) setState({ picks: state.picks.concat([i]) });
      return;
    }
    if (a === 'unpick') {
      setState({ picks: state.picks.filter(function (_, j) { return j !== i; }) });
      return;
    }
    if (a === 'view3') {
      if (!state.view3) {
        var panel = root.querySelector('[data-so-pitch]');
        pendingFly = panel ? panel.getBoundingClientRect() : null;
      }
      setState({ view3: k });
      return;
    }
    if (a === 'acc3') { setState({ acc3: state.acc3 === k ? null : k }); return; }
    if (a === 'next3') { setState({ acc3: nextKey(k) }); return; }
    if (a === 'pickenc') { setState({ encore: { s: k, i: i } }); return; }
    if (a === 'clearenc') { setState({ encore: null }); return; }
    if (a === 'finish') { go(4); return; }
    if (a === 'startover') { resetAll(); return; }
    if (a === 'extras') {
      if (!EX) return;
      setState({ move: 5, view5: state.view5 || state.styleSel, acc5: state.acc5 || state.styleSel });
      window.scrollTo({ top: 0 });
      return;
    }
    if (a === 'view5') { setState({ view5: k }); return; }
    if (a === 'acc5') { setState({ acc5: state.acc5 === k ? null : k }); return; }
    if (a === 'next5') { setState({ acc5: nextKey(k) }); return; }
    if (a === 'pick5') {
      if (!EX) return;
      if (state.extras.length >= EX_MAX) { toast(exText('full', 'That’s [max] — the most a set takes.')); return; }
      setState({ extras: state.extras.concat([{ s: k, i: i }]) });
      return;
    }
    if (a === 'unpick5') {
      setState({ extras: state.extras.filter(function (_, j) { return j !== i; }) });
      return;
    }
    if (a === 'checkout') {
      t.classList.add('so-btn--disabled');
      addSetToCart().then(function () {
        try { sessionStorage.removeItem(STORE_KEY); } catch (err) {}
        window.location.href = config.checkoutUrl || '/checkout';
      }).catch(function (err) {
        t.classList.remove('so-btn--disabled');
        if (err && err.message !== 'busy' && err.message !== 'no product') toast('Couldn’t add the set — give it another go.');
      });
      return;
    }
    if (a === 'another') {
      addSetToCart().then(function () {
        toast('Set added to your bag. Encore — build the next one.');
        resetAll();
      }).catch(function (err) {
        if (err && err.message !== 'busy' && err.message !== 'no product') toast('Couldn’t add the set — give it another go.');
      });
      return;
    }
  });

  render();
})();
